/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

import Types from '../../../modules/types';

const {
  CONTENT_BUILDER_EFFECT: { TYPE_MAP: CBEF_MAP },
} = Types;

const isNotBackground = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'BACKGROUND',
]);

const isNotBackgroundTypeColor = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'COLOR',
]);

const isNotBackgroundTypeGradient = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'GRADIENT',
]);

const isNotBackgroundTypeImage = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'IMAGE',
]);

const isNotBackgroundTypeImageSizeCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'image_size',
  '!==',
  'CUSTOM',
]);

const isNotBackgroundTypeGradientTypeSimple = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'gradient_type',
  '!==',
  'SIMPLE',
]);

const isNotBackgroundTypeGradientTypeCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'gradient_type',
  '!==',
  'CUSTOM',
]);

const ITEM_FIELDS = Admin.compileFromLibrary([
  ['FieldHidden', {
    name: 'type',
  }],
  // ALL
  ['FieldSelect', {
    label: null,
    name: 'blendMode',
    prefix: 'Blend Mode:',
    initialValue: 'NORMAL',
    choices: ['Normal', 'Overlay', 'Multiply', 'Screen'].map(label => ({
      label,
      value: label.toUpperCase(),
    })),
  }],
  // COLOR
  ['FieldColorPicker', {
    label: null,
    name: 'color_color',
    prefix: 'Color:',
    useAlpha: true,
    preSkip: [isNotBackgroundTypeColor],
  }],
  // IMAGE
  ['FieldUploadRefsHorizontal', {
    name: 'image_image',
    label: null,
    accept: 'image/jpg,image/jpeg,image/png,image/svg+xml,image/webp',
    transformations: [
      ['GM', { command: 'compress', maxWidth: 2000 }],
      ['GM', { command: 'webp' }],
    ],
    listType: 'picture',
    uploadLabel: 'Upload Image',
    maxCount: 1,
    preSkip: [isNotBackgroundTypeImage],
  }],
  ['FieldRadio', {
    name: 'image_repeat',
    label: null,
    initialValue: false,
    choices: [{
      label: 'Repeat',
      value: true,
    }, {
      label: 'No Repeat',
      value: false,
    }],
    block: true,
    preSkip: [isNotBackgroundTypeImage],
  }],
  getFilterWithCol(['FieldText', {
    name: 'image_position.x',
    label: null,
    prefix: 'Position X:',
    preSkip: [isNotBackgroundTypeImage],
  }], 12),
  getFilterWithCol(['FieldText', {
    name: 'image_position.y',
    label: null,
    prefix: 'Position Y:',
    preSkip: [isNotBackgroundTypeImage],
  }], 12),
  ['FieldRadio', {
    name: 'image_size',
    label: null,
    initialValue: 'COVER',
    choices: ['Cover', 'Contain', 'Custom'].map(label => ({
      label,
      value: label.toUpperCase(),
    })),
    block: true,
    preSkip: [isNotBackgroundTypeImage],
  }],
  ['FieldText', {
    name: 'image_sizeCustom',
    label: null,
    prefix: 'Custom Size:',
    skip: [isNotBackgroundTypeImageSizeCustom],
    preSkip: [isNotBackgroundTypeImage],
  }],
  // GRADIENT
  ['FieldRadio', {
    label: null,
    name: 'gradient_type',
    initialValue: 'SIMPLE',
    block: true,
    choices: [{
      label: 'Simple',
      value: 'SIMPLE',
    }, {
      label: 'Custom',
      value: 'CUSTOM',
    }],
    preSkip: [isNotBackgroundTypeGradient],
  }],
  // SIMPLE
  getFilterWithCol(['FieldColorPicker', {
    label: null,
    name: 'gradient_colorStart',
    prefix: 'Start Color:',
    useAlpha: true,
    skip: [isNotBackgroundTypeGradientTypeSimple],
    preSkip: [isNotBackgroundTypeGradient],
  }], 12),
  getFilterWithCol(['FieldColorPicker', {
    label: null,
    name: 'gradient_colorEnd',
    prefix: 'End Color:',
    useAlpha: true,
    skip: [isNotBackgroundTypeGradientTypeSimple],
    preSkip: [isNotBackgroundTypeGradient],
  }], 12),
  getFilterWithCol(['FieldText', {
    label: null,
    name: 'gradient_direction',
    prefix: 'Direction:',
    type: 'number',
    addonAfter: 'deg',
    align: 'right',
    initialValue: 0,
    skip: [isNotBackgroundTypeGradientTypeSimple],
    preSkip: [isNotBackgroundTypeGradient],
  }], 24),
  // CUSTOM
  getFilterWithCol(['FieldTextArea', {
    label: null,
    name: 'gradient_customValue',
    skip: [isNotBackgroundTypeGradientTypeCustom],
    preSkip: [isNotBackgroundTypeGradient],
    autoSize: { minRows: 3 },
  }], 24),
], true);

Admin.addToLibrary(
  'FieldContentBuilderEffects:BACKGROUND:ITEM',
  (config = {}) => Admin.compileFromLibrary(['FieldContentBuilderNodes', {
    name: 'background_items',
    preSkip: [isNotBackground],
    addButtonChoices: CBEF_MAP.BACKGROUND.children.background_items.TYPE_ITEMS,
    addButtonLabel: 'Add Background',
    pasteButtonLabel: 'Paste Background',
    toolbarProps: {
      items: CBEF_MAP.BACKGROUND.children.background_items.TYPE_ITEMS,
      // eslint-disable-next-line max-len
      itemsLabelsMap: CBEF_MAP.BACKGROUND.children.background_items.TYPE_LABELS_MAP,
    },
    copyRealm: 'ContentBuilder:Effect:BACKGROUND:bacground_items',
    pasteRealm: 'ContentBuilder:Effect:BACKGROUND:bacground_items:*',
    fields: [
      ...ITEM_FIELDS,
    ],
    nodeType: CBEF_MAP.BACKGROUND.children.background_items.node,
    targetable: false,
    ...config,
  }]),
);

export default [
  ...[

  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotBackground, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderEffects:BACKGROUND:ITEM', {
    name: 'background_items',
  }],
];
